import { apiClient } from '@/lib/apiClient'

export interface PublicSettings {
  siteName: string
  siteDescription: string
  businessTimezone: string
  maxGameAccounts: number
  allowRegistration: boolean
  maintenanceMode: boolean
  maintenanceMessage: string
  minecraftVersion: string
  beianNumber?: string
  copyrightText?: string
}

export async function getPublicSettings(): Promise<PublicSettings> {
  const response = await apiClient.get<{
    code: number
    data: PublicSettings
    message: string
  }>('/public/settings', {
    skipAuthHeader: true,
    skipAuthRefresh: true,
  })

  return response.data
}
